export default __webpack_public_path__ + "static/media/mon_64.eaca7fb2.png";